import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import '@app/app.module';
